import React from 'react';
import { summarizeOutreach } from '../utils/driverOutreachDisplay';

const OutreachCallStatus = ({ calls, compact = false }) => {
  const summary = summarizeOutreach(calls);
  if (!summary) return null;

  return (
    <div
      style={{
        marginTop: compact ? 4 : 8,
        padding: compact ? '4px 8px' : '6px 10px',
        borderRadius: 6,
        fontSize: compact ? 11 : 12,
        fontWeight: 600,
        lineHeight: 1.35,
        ...summary.badgeStyle,
      }}
    >
      <div>
        <i className="fa fa-phone" style={{ marginRight: 6 }} aria-hidden="true" />
        {summary.summaryText}
      </div>
      {!compact && summary.when ? (
        <div style={{ fontSize: 11, fontWeight: 500, marginTop: 3, opacity: 0.9 }}>
          Last call: {summary.when}
          {summary.latest.rejection_notes ? ` — ${summary.latest.rejection_notes}` : ''}
        </div>
      ) : null}
    </div>
  );
};

export default OutreachCallStatus;
